module.exports = __webpack_public_path__ + "static/img/5.b1f7a7c.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/2/4/zh/5.png
// module id = Cu/r
// module chunks = 0